<template>
  <div class="h-screen w-full bg-gray-50 flex items-center justify-center px-6 md:px-10">
    <div class="w-full max-w-md space-y-6">
      <div class="text-center">
        <h1 class="text-3xl text-gray-900">Login</h1>
        <p class="mt-2 text-sm text-gray-500">Acesse sua conta para continuar.</p>
      </div>

      <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="space-y-4 p-6">
          <div v-if="!liberarCodigo" class="flex flex-col gap-1">
            <label class="text-sm font-medium text-gray-500">E-mail</label>
            <input
              v-model="form.email"
              type="email"
              placeholder="Digite seu e-mail..."
              class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
            />
          </div>

          <div v-if="!liberarCodigo" class="flex flex-col gap-1">
            <label class="text-sm font-medium text-gray-500">
              {{ $t("txt-password") }}
            </label>

            <div class="relative">
              <input
                v-model="form.password"
                :type="visualizarSenha ? 'text' : 'password'"
                placeholder="Digite sua senha..."
                class="h-11 w-full rounded-xl border border-gray-200 px-4 pr-11 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
              />

              <button type="button" @click="visualizarSenha = !visualizarSenha" class="absolute inset-y-0 right-3 flex items-center text-gray-300 transition duration-200 hover:text-gray-500">
                <svg v-if="!visualizarSenha" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0Z" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7Z" />
                </svg>

                <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 3l18 18" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10.584 10.587A2 2 0 0012 14a2 2 0 001.414-.586" />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9.879 5.583A10.01 10.01 0 0112 5c4.478 0 8.268 2.943 9.542 7a9.964 9.964 0 01-2.043 3.368M6.228 6.228C4.521 7.352 3.229 9.015 2.458 12c1.274 4.057 5.065 7 9.542 7a9.98 9.98 0 004.132-.892"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div v-if="liberarCodigo" class="flex flex-col gap-1">
            <label class="text-sm font-medium text-gray-500">Código MFA</label>
            <input
              v-model="form.codigo"
              type="text"
              placeholder="Digite o código..."
              class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
            />
          </div>

          <button
            @click="liberarCodigo ? autenticacaoDoisFatores() : login()"
            type="button"
            class="group mt-2 flex h-11 w-full items-center justify-center gap-2 rounded-xl bg-blue-500 font-medium text-white transition hover:bg-blue-600 hover:shadow-md"
          >
            <span>{{ textoBotao }}</span>

            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 transform transition-all duration-300 group-hover:translate-x-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginDestination } from "../router/loginDestination";

export default {
  name: "Login",

  data: function () {
    return {
      form: {
        email: "",
        password: "",
        codigo: ""
      },
      liberarCodigo: false,
      visualizarSenha: false,
      textoBotao: "Entrar"
    };
  },

  methods: {
    async autenticacaoDoisFatores() {
      const resp = await this.$http.post("/login", this.form);

      if (!resp.data.success) {
        this.$vToastify.error(this.$t(resp.data.err));
      } else {
        this.err = false;
        localStorage.setItem("token", resp.data.token);
        localStorage.setItem("user", JSON.stringify(resp.data.user));
        this.$store.commit("login", resp.data.user);

        if (resp.data.user.operador) {
          await this.$http.post("/v1/operador/sessao", {
            id: resp.data.user._id
          });
        }

        return this.$router.push({ path: loginDestination(resp.data.user) });
      }
    },

    async login() {
      const resp = await this.$http.post("/login", {
        email: this.form.email,
        password: this.form.password
      });

      if (!resp.data.success) {
        this.$vToastify.error(this.$t(resp.data.err));
      } else if (resp.data.precisaDoisFatores) {
        this.liberarCodigo = true;
        this.textoBotao = "Autenticar";
      } else {
        this.err = false;
        localStorage.setItem("token", resp.data.token);
        localStorage.setItem("user", JSON.stringify(resp.data.user));
        this.$store.commit("login", resp.data.user);

        if (resp.data.user.operador) {
          await this.$http.post("/v1/operador/sessao", {
            id: resp.data.user._id
          });
        }

        return this.$router.push({ path: loginDestination(resp.data.user) });
      }
    }
  },

  async beforeMount() {
    const token = localStorage.getItem("token");

    if (!token) return;

    const user = JSON.parse(localStorage.getItem("user"));

    if (user) return this.$router.push({ path: loginDestination(user) });
  }
};
</script>
